import { render, staticRenderFns } from "./RankList.vue?vue&type=template&id=5fbdea06&scoped=true&"
import script from "./RankList.vue?vue&type=script&lang=js&"
export * from "./RankList.vue?vue&type=script&lang=js&"
import style0 from "./rank-list.css?vue&type=style&index=0&id=5fbdea06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbdea06",
  null
  
)

export default component.exports